<template>
  <div class="gr-logo" v-html="GrLogo"></div>
</template>

<script>
import GrLogo from './gr_logo.svg'
export default {
  data () {
    return {
      GrLogo: GrLogo
    }
  }
}
</script>



// WEBPACK FOOTER //
// uncommon-client/components/svgs/GrLogo.vue